import { makeStyles } from 'tss-react/mui';

import { deepOrange } from '@mui/material/colors';

export default makeStyles()({
    signIn: {
        fontSize: 14,
        fontWeight: 600
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 14
    },
    containerAdaptive: {
        '@media (max-width: 960px)': {
            justifyContent: 'center'
        }
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        lineHeight: 1
    },
    textContainerAdaptive: {
        '@media (max-width: 960px)': {
            display: 'none'
        }
    },
    userName: {
        fontWeight: 700,
        color: '#4D4D4D',
        textTransform: 'capitalize'
    },
    creditsLabel: {
        fontWeight: 400,
        color: '#9E9E9E'
    },
    creditsCount: {
        color: '#FF6600'
    },
    avatar: {
        cursor: 'pointer',
        backgroundColor: deepOrange[500],
        width: 32,
        height: 32
    },
    badge: {
        padding: 3,
        minWidth: 0,
        minHeight: 0,
        height: 'auto',
        width: 'auto',
        background: 'linear-gradient(249.05deg, #FF8B61 7.18%, #D92E7F 172.88%)',
        color: '#fff'
    },
    badgeIcon: {
        fontSize: 9
    }
});
